













import Vue from 'vue'
import VerificationsItem from '@/UI/Auction/Verifications/VerificationsItem.vue'
import { VerificationData } from '@/Infrastructure/Store/Auction/VerificationData'

export default Vue.extend({
  name: 'VerificationsForm',
  components: {
    VerificationsItem
  },
  props: {
    previusVerificationData: {
      type: Array as () => VerificationData[]
    },
    procedureId: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    },
    arraIds: Array as () => number[]
  }
})
